<template><div><h1>VUX V2.5.0 released</h1>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] Support prop:close-on-confirm</li>
<li>[feature] Support prop:show-input</li>
</ul>
<h2><a href="/en/components/datetime-view.html">DatetimeView</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul><li>[feature] Add prop:transition</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[feature] Add primary、warn disabled bg color. #1630</li>
</ul>
<h2><a href="/en/components/x-switch.html">XSwitch</a></h2>
<ul><li>[feature] we can use prop:prevent-default to prevent from setting value on being clicked #1606</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.0-111.vue?1152d565